import React, { useEffect, useState } from "react";



function HomePopup({ isOpen, onClose }) {
    const [animateIn, setAnimateIn] = useState(false);

    useEffect(() => {
      if (!isOpen) {
        setAnimateIn(false);
        return;
      }

      const timer = setTimeout(() => {
        setAnimateIn(true);
      }, 30);

      return () => clearTimeout(timer);
    }, [isOpen]);

    if (!isOpen) return null;

    return (
      <div
        className="modal fade show popup-bg"
        id="invitationModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="false"
        style={{
          display: "block",
          opacity: animateIn ? 1 : 0,
          transition: "opacity 300ms ease"
        }}
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          onClick={(e) => e.stopPropagation()}
          style={{
            transform: animateIn ? "translateY(0) scale(1)" : "translateY(20px) scale(0.96)",
            opacity: animateIn ? 1 : 0,
            transition: "transform 320ms ease, opacity 320ms ease"
          }}
        >
          <div className="modal-content over-radiyes position-relative p-2 p-lg-4">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
              style={{
                position: "absolute",
                right: 7,
                top: 6,
                fontSize: 10,
                color: "#000"
              }}
            />
            <div className="row">
              <div className="col-lg-4">
                <div className="prakash-img">
                  <img src="assets/img/prakash.jpg" alt="prakash image" />
                  <h3>
                    Prakash Kumar Singh <span>Founder &amp; CEO</span>
                  </h3>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="invitation-content">
                  <p>
                    <strong>मैं प्रकाश कुमार सिंह</strong>, Founder &amp; CEO, विवाह
                    श्री प्राइवेट लिमिटेड, आज आप सभी को हमारे प्लेटफॉर्म के बारे में
                    बताना चाहता हूँ।
                  </p>
                  <p>
                    विवाह श्री का मुख्य उद्देश्य है समाज में मजबूत और सफल वैवाहिक
                    रिश्ते बनाना। आज के समय में हम देख रहे हैं कि जितनी जल्दी शादियां
                    हो रही हैं, उतनी ही जल्दी रिश्तों में टूटन और तलाक के मामले भी बढ़
                    रहे हैं। इसका मुख्य कारण है गलत मैचिंग – जहां सोच, रहन-सहन, परिवार
                    और जीवनशैली में सामंजस्य नहीं होता।
                  </p>
                  <p>
                    इसी समस्या का समाधान लेकर हम विवाह श्री प्लेटफॉर्म लेकर आए हैं।
                    हमारा मिशन है कि हर व्यक्ति को उसके अनुसार सही जीवनसाथी मिले और
                    शादी एक मजबूत और स्थायी रिश्ता बने। विवाह श्री की खासियत यह है कि
                    इसमें <strong>20+ एडवांस फिल्टर</strong> दिए गए हैं, जिनकी मदद से
                    आप अपनी पसंद और परिवार की सोच के अनुसार सही रिश्ता ढूंढ सकते हैं।
                    इसमें माता-पिता की भूमिका सबसे महत्वपूर्ण रखी गई है, ताकि निर्णय
                    सोच-समझकर लिया जा सके।
                  </p>
                  <p>
                    हम अपने प्लेटफॉर्म पर
                    <strong>
                      Aadhaar verification, Address verification, police verification,
                      Education verification, job verification
                    </strong>
                    और <strong>Income verification</strong> जैसी सुविधाएं देते हैं,
                    जिससे आपको पूरी तरह से सुरक्षित और भरोसेमंद प्रोफाइल मिलते हैं।
                    हमारा लक्ष्य केवल शहरों तक सीमित नहीं है, बल्कि हम इस सेवा को
                    गांव-गांव तक पहुंचाना चाहते हैं। इसके लिए हम ऑनलाइन प्लेटफॉर्म के
                    साथ-साथ ऑफलाइन जागरूकता अभियान भी चला रहे हैं।
                  </p>
                  <p>
                    विवाह श्री से जुड़ने का सबसे बड़ा फायदा यह है कि आप आसानी से,
                    सुरक्षित तरीके से और बिना किसी अतिरिक्त खर्च के अपने लिए या अपने
                    बच्चों के लिए सही रिश्ता ढूंढ सकते हैं। वर्तमान में हमारा लक्ष्य
                    <strong>1 लाख verified</strong> प्रोफाइल तैयार करना है। जब तक यह
                    लक्ष्य पूरा नहीं होता, तब तक हमारी <strong>matchmaking</strong>
                    सेवा बिल्कुल मुफ्त रहेगी।
                  </p>
                  <p>
                    हम आप सभी से निवेदन करते हैं कि विवाह श्री से जुड़ें, हमारी ऐप
                    डाउनलोड करें या वेबसाइट पर जाकर रजिस्ट्रेशन करें, और एक बेहतर
                    भविष्य की शुरुआत करें।
                  </p>
                  <p>
                    <strong>धन्यवाद।</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

export default HomePopup;